import React from "react"
import { useDispatch } from "react-redux"
import { useEffect, useState } from "react"
import sortBy from "lodash/sortBy"
import { setPageTitle } from "../../../redux/store/themeConfigSlice"
import { TAwpMessages } from "../../../services/statisticsAPI"
import ChatModal from "./components/ChatModal"
import { useNavigate } from "react-router-dom"
import StickyDataTable from "../../../components/StickyDataTable"
import { getErrorStatus } from "../../../types/error"

const phoneNumberFixer = (phoneNumber: string) => {
  return phoneNumber.replace("whatsapp:", "")
}

const profileNamefixer = (profileName: string) => {
  if (profileName.length > 25) {
    return profileName.slice(0, 25) + "..."
  } else {
    return profileName
  }
}

const WpMessages = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const PAGE_SIZES = [10, 20, 30, 50, 100, 500, 1000]
  const [wpData, setWpData] = useState([])
  const [page, setPage] = useState(1)
  const [pageSize, setPageSize] = useState(PAGE_SIZES[2])
  const [totalPages, setTotalPages] = useState(0)
  const [initialRecords, setInitialRecords] = useState(sortBy(wpData, "id"))
  const [error, setError] = useState<string | null>(null)
  const [loading, setLoading] = useState(false)
  const [isChatModalOpen, setIsChatModalOpen] = useState(false)
  const [selectedChat, setSelectedChat] = useState<any>(null)
  const [sortByColumn, setSortByColumn] = useState<string>("")
  const [sortOrder, setSortOrder] = useState<boolean>(false)

  useEffect(() => {
    dispatch(setPageTitle("WP Mesajları"))
  }, [dispatch])

  useEffect(() => {
    handleFetchData()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page, pageSize, sortByColumn, sortOrder])

  const handleFetchData = async () => {
    setLoading(true)

    try {
      const response = await TAwpMessages(page, pageSize, sortByColumn, sortOrder)
      const data = response.conversations.map((item: any) => {
        return {
          _id: item._id,
          profileName: profileNamefixer(item.profileName),
          from: phoneNumberFixer(item.from),
          ...item,
        }
      })
      setWpData(data)
      setInitialRecords(data)
      setTotalPages(response.totalPages)
      setLoading(false)
    } catch (error: unknown) {
      if (getErrorStatus(error) === 401) {
        navigate("/login")
      }
      setError("No data found")
    }
  }

  const handleSorting = (columnAccessor: string) => {
    if (columnAccessor === sortByColumn) {
      setSortOrder((prevOrder) => !prevOrder)
    } else {
      setSortByColumn(columnAccessor)
      setSortOrder(true)
    }
  }

  return (
    <div className="panel">
      <div className="datatables">
        {loading ? (
          <div className="flex items-center justify-center h-40">
            <div className="animate-spin rounded-full h-10 w-10 border-t-4 border-pink-600"></div>
          </div>
        ) : (
          <>
            <StickyDataTable
              highlightOnHover={true}
              className="whitespace-nowrap"
              records={initialRecords}
              columns={[
                {
                  accessor: "id",
                  title: "Id",
                  sortable: false,
                },
                {
                  accessor: "profileName",
                  title: "Profil İsmi",
                  sortable: false,
                },
                {
                  accessor: "from",
                  title: "Telefon",
                  sortable: false,
                  render: (item: any) => <div>{item.from?.replace("whatsapp:", "")}</div>,
                },
                { accessor: "messageType", title: "Mesaj Türü", sortable: false },
                {
                  accessor: "createdAt",
                  title: "Tarih",
                  sortable: false,
                  render: (item: any) => (
                    <div>{new Date(item.createdAt).toLocaleDateString("tr-TR")}</div>
                  ),
                },
                {
                  accessor: "responseTime",
                  title: "Yanıt Süresi",
                  sortable: false,
                  render: (item: any) => {
                    const createdMs = new Date(item.createdAt).getTime()
                    const nowMs = Date.now()
                    const oneDayMs = 24 * 60 * 60 * 1000
                    const msPassed = nowMs - createdMs

                    if (msPassed >= oneDayMs) {
                      return <span>Yanıt süresi doldu</span>
                    }

                    const msLeft = oneDayMs - msPassed
                    const hoursLeft = Math.floor(msLeft / (1000 * 60 * 60))
                    const minutesLeft = Math.floor((msLeft % (1000 * 60 * 60)) / (1000 * 60))

                    const text = `${hoursLeft} saat ${minutesLeft} dakika kaldı`
                    const isUrgent = msLeft < 3 * 60 * 60 * 1000

                    return <span style={isUrgent ? { color: "red" } : undefined}>{text}</span>
                  },
                },
                {
                  accessor: "chat",
                  title: "Sohbet",
                  sortable: false,
                  render: (item: any) => (
                    <div>
                      <button
                        className="px-4 py-2 bg-blue-500 text-white hover:bg-blue-600 rounded"
                        type="submit"
                        onClick={() => {
                          setIsChatModalOpen(!isChatModalOpen)
                          setSelectedChat(item)
                        }}
                      >
                        Sohbeti Aç
                      </button>
                    </div>
                  ),
                },
              ]}
              totalRecords={totalPages * pageSize}
              recordsPerPage={pageSize}
              page={page}
              onPageChange={(p) => setPage(p)}
              recordsPerPageOptions={PAGE_SIZES}
              onRecordsPerPageChange={setPageSize}
              onSortStatusChange={(e) => handleSorting(e.columnAccessor)}
              minHeight={200}
              paginationText={({ from, to, totalRecords }) =>
                `Showing  ${from} to ${to} of ${totalRecords} entries`
              }
            />
            <ChatModal
              isOpen={isChatModalOpen}
              onClose={() => setIsChatModalOpen(false)}
              chatData={selectedChat}
            />
          </>
        )}
      </div>
    </div>
  )
}

export default WpMessages
